'use client';
import { getCookie, setCookie } from '@/utils/helper';
import { useEffect, useState } from 'react';

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
    const savedCookie = getCookie('user_token');

    if (savedCookie === false) {
      setIsVisible(true);
      setTimeout(() => setIsMounted(true), 100); // Delay before animation starts
    }
  }, []);

  // Don't render anything until hydrated to prevent hydration mismatch
  if (!isHydrated) {
    return null;
  }

  const handleAccept = () => {
    setIsMounted(false);
    setTimeout(() => setIsVisible(false), 1200); // Wait for animation before removing
    setCookie('user_token', 'accepted', 365);
  };

  const handleClose = () => {
    setIsMounted(false);
    setTimeout(() => setIsVisible(false), 1200); // Wait for animation before removing
    setCookie('user_token', 'accepted', 365);
  };

  return (
    <>
      {isVisible && (
        <div
          className={`duration-1200 fixed bottom-0 left-0 z-50 flex h-[150px] w-full flex-col items-center justify-center gap-8 bg-[#2B373B] px-12 text-white opacity-[.8] shadow-lg transition-all ease-out min-[450px]:h-fit min-[450px]:flex-row min-[450px]:gap-2 min-[450px]:p-2 md:gap-4 ${
            isMounted ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
          }`}
        >
          <div className="text-center text-sm sm:text-lg">
            This website makes use of cookies to enhance browsing experience and provide additional functionality.
            <a href="/page/cookies-policy/" className="ml-2 text-blue-400 hover:underline">
              Details
            </a>
          </div>
          <div className="flex gap-2">
            <button
              className="h-12 w-[115px] border-2 border-[#2B373B] bg-white p-2 text-xl text-black transition duration-150 ease-linear hover:bg-gray-200 hover:underline"
              onClick={handleAccept}
            >
              Allow cookies
            </button>
            <button
              className="h-12 w-[115px] border-2 border-[#2B373B] bg-white p-2 text-xl text-black transition duration-150 ease-linear hover:bg-gray-200 hover:underline"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}
